import React, { memo, useMemo } from 'react';
import Container from 'Nori/Container';
import Card from 'Custom/Card';
import CarouselNavigation from 'Custom/Carousel/CarouselNavigation';
import styles from 'Custom/Carousel/index.module.scss';
import MultipleCarousel from 'Nori/MultipleCarousel';

const Carousel = ({ items = [], ...props }) => {
  const navigationItems = items.map(({ navigationTitle }) => ({
    navigationTitle,
  }));

  return (
    <div className={styles.carousel} {...props} data-qa-tag="carousel-section">
      <MultipleCarousel
        data-qa-tag="multiple-carousel-section"
        showDots={true}
        navigationItems={navigationItems}
        className={styles.carouselWrapper}
      >
        {items.map((item, i) => (
          <Card
            data-qa-tag="carousel-card-section"
            key={`carousel-card-${i}`}
            title={item.title}
            subtitle={item.subtitle}
            image={item.image}
          >
            {item.content}
          </Card>
        ))}
      </MultipleCarousel>
    </div>
  );
};

export default Carousel;
